// src/app/login/page.tsx
"use client";

import { useEffect, useState } from "react";
import { useRouter, useSearchParams } from "next/navigation";
import axios from "axios";
import { setToken, isLoggedIn } from "@/lib/auth";
import { buildStrapiApiUrl } from "@/lib/strapiApi";
import { useTenant } from "@/context/TenantContext";

const resolvePostLoginPath = (nextParam: string | null): string => {
  if (!nextParam || !nextParam.startsWith('/')) {
    return '/admin/dashboard';
  }
  if (nextParam.startsWith('//')) {
    return '/admin/dashboard';
  }
  return nextParam;
};

export default function LoginPage() {
  const router = useRouter();
  const searchParams = useSearchParams();
  const { refreshTenant } = useTenant();
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const postLoginPath = resolvePostLoginPath(searchParams.get('next'));

  useEffect(() => {
    if (!isLoggedIn()) return;

    const redirectAfterLogin = async () => {
      await refreshTenant();
      router.replace(postLoginPath);
    };

    void redirectAfterLogin();
  }, [refreshTenant, router, postLoginPath]);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setIsSubmitting(true);

    try {
      const res = await axios.post(buildStrapiApiUrl("/api/auth/local"), {
        identifier,
        password,
      });

      const token = res.data?.jwt;
      if (!token) {
        setError("Неверный ответ от сервера");
        return;
      }

      setToken(token);
      await refreshTenant();
      router.replace(postLoginPath);
    } catch {
      setError("Неверный логин или пароль");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <form
        onSubmit={handleLogin}
        className="bg-white p-8 rounded-xl shadow-md w-96 space-y-4"
      >
        <h1 className="text-2xl font-bold text-center">Вход в панель</h1>

        {error && <p className="text-red-600 text-sm text-center">{error}</p>}

        <input
          type="email"
          value={identifier}
          onChange={(e) => setIdentifier(e.target.value)}
          placeholder="Email"
          className="w-full border rounded p-2"
        />
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Пароль"
          className="w-full border rounded p-2"
        />

        <button
          type="submit"
          disabled={isSubmitting}
          className="w-full bg-blue-600 text-white p-2 rounded hover:bg-blue-700 transition disabled:opacity-60"
        >
          {isSubmitting ? "Вход…" : "Войти"}
        </button>
      </form>
    </div>
  );
}
